import { useEffect, useState } from "react";
import { LikeOutlined, DislikeOutlined } from "@ant-design/icons";
import { generateUuid, getAgentFromScript } from "@/utils";
import { editPraise } from "@/services";
import { LikeTypeEnmu } from "@/constants";
import toast from "react-hot-toast";
import { useI18n } from "@/contexts/I18nContext";
import styles from "./index.module.scss";

interface MessageProps {
  find_answer: number;
  id: string;
  message: string;
  role: string;
  is_helpful: number;
}

const LikeComponent = ({ message }: any) => {
  const { id: messageId, is_helpful }: MessageProps = message;
  const [action, setAction] = useState<number | null>(null);
  const { formatMessage } = useI18n();

  const handleAction = async (action: number) => {
    const res: any = await editPraise({
      agent: getAgentFromScript(),
      messageId: messageId || generateUuid(),
      is_helpful: action,
    });
    if (res.code === 0) {
      toast.success(formatMessage("thankEvaluation"));
    }
  };

  useEffect(() => {
    setAction(is_helpful);
  }, [is_helpful]);

  return (
    <div className={styles.likeContainer}>
      <span
        id="add_to_like_button"
        data-track-element
        className={`${styles.iconWrapper}
          ${action === LikeTypeEnmu.USEFUL ? styles.active : ""}`}
        onClick={() => {
          setAction(LikeTypeEnmu.USEFUL);
          handleAction(LikeTypeEnmu.USEFUL);
        }}
      >
        <LikeOutlined className={styles.likeIcon} />
      </span>
      <span
        id="add_to_dislike_button"
        data-track-element
        className={`${styles.iconWrapper}
          ${action === LikeTypeEnmu.UNUSEFUL ? styles.active : ""}`}
        onClick={() => {
          setAction(LikeTypeEnmu.UNUSEFUL);
          handleAction(LikeTypeEnmu.UNUSEFUL);
        }}
      >
        <DislikeOutlined className={styles.dislikeIcon} />
      </span>
    </div>
  );
};

export default LikeComponent;
